export enum CookieNames {
  PHOENIX_ENABLED = "phoenixEnabled",
}
